<app-header [ngClass]="{'header': true, 'nav-fixed': isFixed}"></app-header>
<div id="content" class="content">
    <router-outlet *ngIf="isPlatformBrowser"></router-outlet>
</div>